// extracted by mini-css-extract-plugin
module.exports = {"root":"PasswordPage_root__2d1MV","buttons":"PasswordPage_buttons__3hEk3"};